import axios, { InternalAxiosRequestConfig, AxiosResponse } from 'axios';

import { errorHandler, responseHandler } from './http-common';

import { apiAddress, monitorApiAddress } from '../config';

const TIMEOUT = 15000; // 15 seconds

const requestHandler = (request: InternalAxiosRequestConfig) => {
    request.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;

    return request;
};

const axiosAPI = axios.create({
    baseURL: apiAddress,
    timeout: TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosAPI.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error),
);

axiosAPI.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => Promise.reject(errorHandler(error)),
);

export default axiosAPI;
